module.exports = __webpack_public_path__ + "img/ukas.e4a8c304.jpg";